import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotasService {

  constructor(private http: HttpClient) { }

  getNotas() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Notas/All");
  }

  getNotasHome() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Notas/Home");
  }

  getByUrl(url: string) {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Notas/ByUrl?url="+url);
  }

  buscador(parametropo: string) {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Notas/buscador?Termino="+parametropo);
  }
}